import React, {useMemo, useState} from 'react'

const RecipeConText = React.createContext()
RecipeConText.displayName = 'RecipeCreateContext'

const RecipeProvider = ({children}) => {
    const [productionCosts, setProductionCosts] = useState({})
    const [rowState, setRowState] = useState({})
    const [abstractState, setAbstractState] = useState({})
    const [ingredientsTotals, setIngredientsTotals] = useState(0)

    const calculateMaterialsSubTotal = () => {
        let midTotal = 0

        Object.keys(rowState).map(key => {
            let item = rowState[key]
            if (item.data) {
                midTotal += item.quantity * item.parity * item.data.price
            }
        })

        return midTotal
    }

    const calculateTotalProductionCost = () => {
        let total = 0
        Object.keys(productionCosts).map(key => total += productionCosts[key].ratio)
        return total
    }

    const calculateRecipeTotal = () => productMidTotal + productionCostTotal

    const calculateSubTotals = () => {
        let subTotalObj = {
            "EUR": [],
            "USD": [],
            "TRY": []
        }

        Object.keys(rowState).map(key => {
            let item = rowState[key]
            if (item.data) {
                let subTotal = item.quantity * (item.unitPrice ? item.unitPrice : item.data.price) * item.parity
                subTotalObj[item.data.currency].push(subTotal)

            }
        })

        return subTotalObj
    }

    const subTotals = useMemo(() => calculateSubTotals(), [rowState])
    const productMidTotal = useMemo(() => calculateMaterialsSubTotal(), [productionCosts, subTotals])
    const productionCostTotal = useMemo(() => calculateTotalProductionCost(), [productionCosts])
    const recipeTotal = useMemo(() => calculateRecipeTotal(), [productMidTotal, productionCostTotal])

    const values = {
        rowData: [rowState, setRowState],
        subTotals: subTotals,
        recipeAbstract: [abstractState, setAbstractState],
        ingredientsSubTotal: [ingredientsTotals, setIngredientsTotals],
        prodCostsTotal: productionCostTotal,
        recipeTotal: recipeTotal,
        productionData: [productionCosts, setProductionCosts],
        productionMidTotal: productMidTotal
    }

    return (
        <RecipeConText.Provider value={values}>
            {children}
        </RecipeConText.Provider>
    )
}

export {RecipeConText, RecipeProvider}

